import { makeStyles, shorthands } from "@fluentui/react-components";

import { StyleConstants } from "Shared/Styles/StyleConstants";
import { themeTokens } from "Core/Theme";

export const useOverflowMenuStyles = makeStyles({
    root: {},
    trigger: {
        minWidth: 0,
        ...shorthands.padding(0)
    },
    menu: {
        left: `${StyleConstants.leftBarWidth}px`,
        maxWidth: "420px",
        width: "360px",
        display: "flex",
        flexDirection: "column",
        alignContent: "center",
        alignItems: "center"
    },
    appList: {
        height: "300px",
        overflowY: "auto",
        display: "flex",
        flexWrap: "wrap",
        alignContent: "flex-start",
        ...shorthands.padding("16px"),
        width: "90%"
    },
    footer: {
        bottom: 0,
        height: "64px",
        display: "flex",
        justifyContent: "flex-end",
        alignContent: "center",
        width: "336px",
        ...shorthands.borderTop("1px", "solid", themeTokens.colorNeutralStroke1),
        ...shorthands.margin(0, "12px")
    },
    button: {
        ...shorthands.margin("16px", 0, "12px", 0)
    },
    input: {
        backgroundColor: themeTokens.colorNeutralBackground3,
        width: "90%",
        marginTop: "16px",
        ...shorthands.border(0),
        color: themeTokens.colorNeutralForeground2
    },
    popover: {},
    menuitem: {}
});
